<template>
  <div class="comment-one" :class="!moveReply && 'hover-visible'">
    <div
      class="comment-avatar"
      :style="{ transform: `scale(${comment.userLevel > 5 ? 0.8 : 1})` }"
    >
      <fps-avatar
        class="pointer"
        :src="comment.avatarUrl"
        :level="comment.userLevel"
        :dressup="comment.avatarFrame"
        @click.native="openPlayerDetail"
      />
    </div>
    <div class="comment-content">
      <div class="comment-nickname">
        <span>{{ comment.nickname }}</span>
        <fps-icon
          v-if="comment.userUuid == adminUuid"
          type="v-mark"
          class="is-admin"
          size="18"
          color="#FFA24E"
        />
        <div
          v-else
          class="userlevel-tag level-mg"
          :class="`level-${comment.userLevel}`"
        ></div>
      </div>
      <div class="comment-text">{{ comment.content }}</div>
      <div class="comment-time">
        <span>{{ timeToMin(comment.createTime) }}</span>
        <button @click="toWriteReply">回覆</button>
      </div>
      <div v-if="showWriteReply" class="write-reply-wrap">
        <div class="write-reply" @click="replyWriteFocus">
          <textarea
            v-model="replyText"
            ref="reply_write"
            class="reply-area"
            :maxlength="maxlength"
            rows="3"
            @click.stop
          />
          <span class="write-count"
            >{{ replyText.length }}/{{ maxlength }}</span
          >
        </div>
        <div class="reply-btns">
          <button class="cancel-reply" @click="showWriteReply = false">
            取消
          </button>
          <button class="confirm-reply" @click="submitReply">
            <i v-if="submitingReply" class="el-icon-loading"></i>
            <span v-else>提交</span>
          </button>
        </div>
      </div>
      <CommentReply
        v-if="comment.replyCount"
        v-model="comment.replyCount"
        class="comment-reply"
        :replyList="comment.replyList"
        :masterUuid="masterUuid"
        :showReply="showReply"
        @replycomment="addReply"
        @mouseenter.native="moveReply = true"
        @mouseleave.native="moveReply = false"
        @deletereply="$emit('deletereply', $event)"
        @updatereply="$emit('updatereply', $event)"
      />
    </div>
    <FeedTool
      v-if="comment.userUuid !== adminUuid"
      class="feed-tool"
      :operateUuid="comment.userUuid"
      :masterUuid="masterUuid"
      @clickdelete="deleteComment"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CommentReply from './reply';
import FeedTool from './feed-tool';
import { writeMomentReply, deleteComment } from './moment';

export default {
  components: {
    CommentReply,
    FeedTool
  },
  props: {
    comment: {
      type: Object,
      default: () => ({})
    },
    masterUuid: {
      type: String,
      require: true
    },
    showReply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showWriteReply: false,
      replyText: '',
      maxlength: 140,
      submitingReply: false,
      moveReply: false
    };
  },
  computed: {
    ...mapGetters(['adminUuid'])
  },
  methods: {
    deleteComment() {
      if (this.deleting) return;
      this.deleting = true;
      deleteComment({
        commentId: this.comment.id
      })
        .then(() => {
          this.$message.success('刪除成功');
          this.$emit('deletecomment');
          this.deleting = false;
        })
        .catch(() => {
          this.$message.success('刪除失敗');
          this.deleting = false;
        });
    },
    addReply(data) {
      this.$emit('replycomment', data);
    },
    submitReply() {
      const {
        replyText,
        comment: { id: commentId }
      } = this;
      if (this.submitingReply || !replyText) return;
      this.submitingReply = true;
      writeMomentReply({
        content: replyText,
        commentId
      })
        .then(({ data }) => {
          this.submitingReply = false;
          this.replyText = '';
          this.showWriteReply = false;
          this.$message.success('提交成功');
          this.addReply(data);
        })
        .catch(() => {
          this.$message.error('提交失敗');
          this.submitingReply = false;
        });
    },
    openPlayerDetail() {
      this.$router.push({
        path: '/player-detail/' + this.comment.userUuid
      });
    },
    timeToMin(time) {
      const d = new Date(time);
      const now = Date.now();
      const createTime = d.getTime();
      // 距离现在几分钟
      let sub = Math.floor((now - createTime) / 60 / 1000);
      if (sub < 5) return '剛剛發佈';
      if (sub < 60) return sub + '分鐘前';
      if (sub < 60 * 24) return Math.floor(sub / 60) + '小時前';
      if (sub < 7 * 60 * 24) return Math.floor(sub / 60 / 24) + '天前';
      let month = d.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let date = d.getDate();
      if (date < 10) {
        date = '0' + date;
      }
      return `${d.getFullYear()}-${month}-${date}`;
    },
    toWriteReply() {
      if (!this.$store.state.app.userInfo) {
        this.$util.Login().then(() => {
          this.toWriteReply();
        });
        return;
      }
      this.showWriteReply = true;
      this.$nextTick(() => {
        this.replyWriteFocus();
      });
    },
    replyWriteFocus() {
      const dom = this.$refs.reply_write;
      if (dom) dom.focus();
    }
  }
};
</script>
<style lang="scss" scoped>
.comment-one {
  margin-top: 16px;
  @include flex(center, flex-start);
  position: relative;
  &.hover-visible:hover .feed-tool {
    transform: scale(1);
  }
  .feed-tool {
    position: absolute;
    top: 0;
    right: 0;
    transform: scale(0);
  }
  .comment-avatar {
    width: 38px;
    height: 38px;
    margin-right: 10px;
  }
  .comment-content {
    flex: 1;
    position: relative;
    .comment-reply {
      margin-top: 16px;
    }
    .comment-nickname {
      @include flex(flex-start);
      overflow: hidden;
      font-weight: 500;
      font-size: 14px;
      height: 22px;
      letter-spacing: -0.00025px;
      color: $color-gray-1;
      span {
        @include ellipsis;
      }
      .is-admin {
        margin-left: 3px;
      }
      .userlevel-tag {
        margin-left: 4px;
      }
    }
    .comment-text {
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-2;
      margin-top: 8px;
    }
    .comment-time {
      @include flex(flex-start);
      margin-top: 4px;
      font-size: 12px;
      line-height: 14px;
      color: $color-gray-3;
      button {
        margin-left: 35px;
        &:hover {
          opacity: 0.5;
        }
      }
    }
  }
}
.write-reply {
  background: #f9f9f9;
  border: 1px solid $color-split;
  border-radius: 8px;
  padding: 12px 12px 10px;
  @include flex(flex-start, flex-end, column);
  .reply-area {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    resize: none;
  }
  .write-count {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-4;
  }
}
.write-reply-wrap {
  margin-top: 37px;
  .reply-btns {
    margin-top: 8px;
    @include flex(flex-end);
    button {
      width: 80px;
      height: 32px;
      @include flex;
      font-size: 13px;
      line-height: 18px;
      border-radius: 50px;
    }
    .cancel-reply {
      color: $color-gray-2;
      border: 1px solid $color-split;
      margin-right: 10px;
    }
    .confirm-reply {
      color: $color-gray-1;
      background: $color-yellow;
    }
  }
}
</style>
